import { personName } from '@backrs_ui/grow-ui/src/utils/personName';

import { CoachNotesList } from './CoachNotes/CoachNotesList';
import { MemberTabErrorState } from './MemberTabErrorState';
import { useCurrentMember } from './useCurrentMember';

export const MemberNotesTab = () => {
  const currentMember = useCurrentMember();
  const { member, isError: isMemberError } = currentMember;

  if (isMemberError) return <MemberTabErrorState {...currentMember} />;
  if (!member) return null;

  return <CoachNotesList userId={member.id} subjectName={personName(member)} />;
};
